import styled from 'styled-components';
import { Body4 } from '../../../common/typography';

export const PreviewCardContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.verdigris};
  border-radius: ${({ theme }) => theme.radius.m};
`;

export const PreviewCardTitle = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.verdigrisDark};
  background-color: ${({ theme }) => theme.colors.mintCream};
  border-top-left-radius: ${({ theme }) => theme.radius.m};
  border-top-right-radius: ${({ theme }) => theme.radius.m};
  padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.m};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AssigneeDueDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const AssigneeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const AssigneeTitle = styled.div`
  margin-right: ${({ theme }) => theme.spacing.s};
`;

export const DueDateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const DueDateTitle = styled.div`
  margin-right: ${({ theme }) => theme.spacing.s};
`;

export const PreviewCardDepartments = styled.div`
  border-radius: 0 ${({ theme }) => theme.radius.m};
  padding: ${({ theme }) => theme.spacing.m};
`;

export const EditButton = styled.button`
  padding: ${({ theme }) => theme.spacing.none};
  width: ${({ theme }) => theme.spacing.l};
  height: ${({ theme }) => theme.spacing.l};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colorsInObjects.gray[600]};
  margin-right: ${({ theme }) => theme.spacing.xs};
  border-radius: ${({ theme }) => theme.radius.xs};
`;

export const DeleteButton = styled.button`
  padding: ${({ theme }) => theme.spacing.none};
  width: ${({ theme }) => theme.spacing.l};
  height: ${({ theme }) => theme.spacing.l};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colorsInObjects.gray[600]};
  border-radius: ${({ theme }) => theme.radius.xs};
`;

export const ActionsButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const PreviewCardSubDepartments = styled(Body4)`
  text-transform: capitalize;
  word-wrap: break-word;
`;
